function a(a,n,d,r){a._m(n);var _=d("f3cab18d");a._(n,"brandsRoute",_),a._(n,"Brands",_);}